import React__default, { createContext, useState, useEffect, useContext } from "react";
import { createPortal } from "react-dom";
import { useDisposables as p } from "../hooks/use-disposables.js";
import { objectToFormEntries as e } from "../utils/form.js";
import { compact as m } from "../utils/render.js";
import { Hidden as T, HiddenFeatures as s } from "./hidden.js";
let f = createContext(null);
function c({ children: t }) {
  let e2 = useContext(f);
  if (!e2) return React__default.createElement(React__default.Fragment, null, t);
  let { target: r } = e2;
  return r ? createPortal(React__default.createElement(React__default.Fragment, null, t), r) : null;
}
function j({ data: t, form: e$1, disabled: r, onReset: n, overrides: F }) {
  let [i, a] = useState(null), p$1 = p();
  return useEffect(() => {
    if (n && i) return p$1.addEventListener(i, "reset", n);
  }, [i, e$1, n]), React__default.createElement(c, null, React__default.createElement(C, { setForm: a, formId: e$1 }), e(t).map(([s$1, v]) => React__default.createElement(T, { features: s.Hidden, ...m({ key: s$1, as: "input", type: "hidden", hidden: true, readOnly: true, form: e$1, disabled: r, name: s$1, value: v, ...F }) })));
}
function C({ setForm: t, formId: e2 }) {
  return useEffect(() => {
    if (e2) {
      let r = document.getElementById(e2);
      r && t(r);
    }
  }, [t, e2]), e2 ? null : React__default.createElement(T, { features: s.Hidden, as: "input", type: "hidden", hidden: true, readOnly: true, ref: (r) => {
    if (!r) return;
    let n = r.closest("form");
    n && t(n);
  } });
}
export {
  j as FormFields,
  c as HoistFormFields
};
